import { MenuItem } from '@models/layout/menu.model';

export const communityModules: MenuItem[] = [
  {
    id: 3,
    label: 'Resident Insights',
    icon: 'bx-bulb',
    subItems: [
      {
        id: 5,
        label: 'Analytics',
        link: './analytics',
        parentId: 3,
      },
      {
        id: 6,
        label: 'Marketing Insights',
        link: './marketing-insights',
        parentId: 3,
      },
      {
        id: 7,
        label: 'Quality of Life',
        link: './quality-of-life',
        parentId: 3,
      },
      {
        id: 10,
        label: 'Actionable Insights',
        link: './actionable-insights',
        parentId: 3,
      },
      {
        id: 11,
        label: 'Uploads',
        link: './uploads',
        parentId: 3,
      },
      {
        id: 30,
        label: 'Downloads',
        link: './downloads',
        parentId: 3,
      },
    ],
  },

  {
    id: 12,
    label: 'Accounts',
    icon: 'bx-user-circle',
    subItems: [
      {
        id: 13,
        label: 'Residents',
        link: './residents',
        parentId: 12,
      },
      {
        id: 14,
        label: 'Staff',
        link: './staff',
        parentId: 12,
      },
      {
        id: 15,
        label: 'Family',
        link: './family',
        parentId: 12,
      },
    ],
  },

  {
    id: 8,
    label: 'Engagement',
    icon: 'bx-pie-chart-alt-2',
    subItems: [
      {
        id: 9,
        label: 'Announcements',
        link: './family-app-notification',
        parentId: 8,
        subItems: [],
      },
      {
        id: 10,
        label: 'Digital Signage',
        link: './digital-signage',
        parentId: 8,
        subItems: [],
      },
      {
        id: 17,
        label: 'Calendar',
        link: './calendar',
        parentId: 8,
      },
      {
        id: 18,
        label: 'Prints',
        link: './calendar/prints',
        parentId: 8,
      },
      {
        id: 19,
        label: 'Clubs',
        link: './clubs/list/all',
        parentId: 8,
      },
      {
        id: 20,
        label: 'Gallery',
        link: './gallery',
        parentId: 8,
      },
      {
        id: 21,
        label: 'Newsletter',
        link: './newsletter',
        parentId: 8,
      },
      {
        id: 22,
        label: 'Messages',
        link: './chat',
        parentId: 8,
      },

      {
        id: 23,
        label: 'Transportation',
        link: './transportation',
        parentId: 8,
      },
      {
        id: 24,
        label: 'Dining Calendar',
        link: './dining-calendar',
        parentId: 8,
      },
    ],
  },

  {
    id: 8,
    label: 'Reports',
    icon: 'bx-circle',
    subItems: [
      {
        id: 16,
        label: 'Attendance Report',
        link: './attendance-report',
        parentId: 8,
      },
      {
        id: 17,
        label: 'Attendance Report Chart',
        link: './attendance-report-chart',
        parentId: 8,
      },
    ],
  },

  {
    id: 9,
    label: 'Content',
    icon: 'bx-customize',
    subItems: [
      {
        id: 20,
        label: 'Catalog',
        icon: 'bx-book-content',
        link: './content/catalog',
      },
      {
        id: 20,
        label: 'Tribune',
        icon: 'bx-book-content',
        link: './tribune',
      },
      {
        id: 922,
        label: 'Spiro 100',
        icon: 'bx-book-content',
        link: './content/spiro100',
      },

      {
        id: 923,
        label: 'Fit Minds',
        icon: 'bx-extension',
        link: './content/fit-minds',
      },

      {
        id: 924,
        label: 'Wowzitude',
        icon: 'bx-extension',
        link: './content/wowzitude',
      },
      {
        id: 925,
        label: 'MasterClass',
        icon: 'bx-extension',
        link: './content/masterclass',
      },
    ],
  },

  {
    id: 23,
    label: 'Feedback',
    icon: 'bx-message-alt',
    subItems: [
      {
        id: 25,
        label: 'Surveys Snapshot',
        parentId: 24,
        link: './feed-back/surveys/snapshot/resident',
      },
      {
        id: 26,
        label: 'Surveys Dashboard',
        parentId: 24,
        link: './feed-back/surveys/dashboard/resident',
      },

      // {
      //   id: 24,
      //   label: 'Survey Platform',
      //   icon: 'bx-message-alt',
      //   subItems: [
      //     {
      //       id: 25,
      //       label: 'Snapshot',
      //       parentId: 24,
      //       link: './feed-back/surveys/snapshot',
      //     },
      //     {
      //       id: 26,
      //       label: 'Dashboard',
      //       parentId: 24,
      //       link: './feed-back/surveys/dashboard',
      //     },
      //   ],
      // },
      {
        id: 27,
        label: 'Feedback Platform',
        icon: 'bx-message-alt',
        link: './feed-back/platform/dashboard',
      },
      {
        id: 28,
        label: 'Resolutions',
        icon: 'bx-message-alt',
        link: './feed-back/platform/investigations',
      },
      {
        id: 29,
        label: 'Kiosk',
        icon: 'bx bx-star',
        link: './feed-back/kiosk',
      },
    ],
  },

  {
    id: 26,
    label: 'Sales Tools',
    icon: 'bx-trending-up',
    subItems: [
      {
        id: 261,
        label: 'Dashboard',
        icon: 'bx-grid-horizontal',
        link: './sales-tool/dashboard',
      },
      {
        id: 262,
        label: 'Prospects',
        icon: 'bx-grid-horizontal',
        link: './sales-tool/prospects',
      },
      {
        id: 263,
        label: 'Personalized Videos',
        icon: 'bx-video',
        link: './sales-tool/personalized-videos',
      },
      {
        id: 264,
        label: 'Video Library',
        icon: 'bx-video-recording',
        link: './sales-tool/video-library',
      },
      {
        id: 265,
        label: 'Clip Library',
        icon: 'bx-video',
        link: './sales-tool/clip-library',
      },
    ],
  },
  {
    id: 27,
    label: 'Compliance (Beta)',
    icon: 'bxs-badge-check',
    subItems: [
      {
        id: 261,
        label: 'Compliance Performance',
        icon: 'bxs-badge-check',
        link: './compliance/compliance-performance',
      },
    ],
  },
];
